
/* ==================================================
   Utility Functions
   ================================================== */

/**
 * Builds an option group for a given type (player, pos, group, etc.).
 *
 * @param {string} optionGroupName - Display title for the group.
 * @param {Array} jsonOptions - Array of items to include in the group.
 * @param {string} type - The type ("player", "pos", "group", etc.).
 * @returns {object} An object defining the option group.
 */
export const buildOptionGroup = (optionGroupName, jsonOptions, type) => {
  const metricObj = {
    label: <span>{optionGroupName}</span>,
    title: optionGroupName,
  };
  const metricOps = [];
  for (let i = 0; i < jsonOptions.length; i++) {
    const metric = jsonOptions[i];
    if (["gps", "forceplate", "testing", "wellness", "nutrition", "cognition"].includes(type)) {
      metricOps.push({
        label: <span>{metric["name"]}</span>,
        value: `${type}-${metric["metric_id"]}`,
        key: metric["metric_id"],
      });
    } else if (type === "player") {
      metricOps.push({
        label: <span>{`${metric["first_name"]} ${metric["last_name"]}`}</span>,
        value: `${type}-${metric["player_id"]}`,
        key: metric["player_id"],
      });
    } else if (type === "pos") {
      metricOps.push({
        label: <span>{metric}</span>,
        value: `${type}-${metric}`,
        key: metric,
      });
    } else if (type === "group") {
      metricOps.push({
        label: <span>{metric["name"]}</span>,
        value: `${type}-${metric["player_group_id"]}`,
        key: metric["player_group_id"],
      });
    }
  }
  metricObj["options"] =
    type === "gps"
      ? metricOps
      : metricOps.sort((a, b) => {
        const valueA = a?.label?.props?.children || "";
        const valueB = b?.label?.props?.children || "";
        return valueA.localeCompare(valueB);
      });
  return metricObj;
};

/**
 * Extracts query parameters from the selection key.
 *
 * @param {string} keyString - A selection key (e.g., "player-5", "group-2", "pos-midfield").
 * @returns {object} Query parameters for the API request.
 */
export const extractPlayerOrPositionalData = (keyString) => {
  if (keyString.startsWith("player")) {
    return {
      player_id: parseInt(keyString.split("-")[1]),
      player_group: null,
      pos_filter: [],
    };
  }
  if (keyString.startsWith("group")) {
    return {
      player_group: [parseInt(keyString.split("-")[1])],
      player_id: null,
      pos_filter: [],
    };
  }
  if (keyString.startsWith("pos")) {
    return {
      player_id: null,
      player_group: null,
      pos_filter: [keyString.split("-")[1]],
    };
  }
  return {
    player_id: null,
    player_group: null,
    pos_filter: [],
  };
};